import React from 'react'
import {ACCOMMODATION_FIXED_HEADER_HEIGHT} from 'components/Accommodation/AccommodationFixedHeader/AccommodationFixedHeader'
import {ScrollSection} from 'components/ScrollSpy'
import {getScrollTargetSpecificRoom} from 'hooks/useHandleScrollToClickedOfferTarget/utils'

import {useDeviceLayout} from '@daedalus/atlas/context/deviceLayout'

import {RoomCardDesktop} from './Desktop/RoomCardDesktop'
import {RoomCardMobile} from './Mobile/RoomCardMobile'
import {RoomCardPropsType} from './types'

export const RoomCard = (props: RoomCardPropsType) => {
  const {isMobile} = useDeviceLayout()

  return (
    <ScrollSection
      scrollTopMargin={isMobile ? 0 : ACCOMMODATION_FIXED_HEADER_HEIGHT}
      name={getScrollTargetSpecificRoom(props.room.id)}
      as="div"
      dataId={`scrollToTarget-roomCard-${props.room.id}`}
    >
      {isMobile ? (
        <RoomCardMobile {...props} />
      ) : (
        <RoomCardDesktop {...props} />
      )}
    </ScrollSection>
  )
}
